import React from 'react';
const NEEDS = [{
  need: 'Need an Electrical Diagnostic Foundations reference?',
  answer: 'It’s there.'
}, {
  need: 'Need a Multimeter Testing pathway?',
  answer: 'It’s there.'
}, {
  need: 'Need a Wiring & Circuit Fault reference?',
  answer: 'It’s there.'
}, {
  need: 'Breaker, Fuse & Protection diagnostics?',
  answer: ''
}, {
  need: 'Motor & Control troubleshooting?',
  answer: ''
}, {
  need: 'Real-World Troubleshooting Cases?',
  answer: ''
}];
export function ReadyToUse() {
  return <section className="bg-carbon px-4 py-4 sm:py-6" data-id="element-162" data-mp="26nafxdapwms0">
      <div className="mx-auto max-w-3xl" data-id="element-163" data-mp="26lpmjr0539vq">
        <h2 className="text-center text-lg leading-tight text-white sm:text-3xl" data-id="element-164" data-mp="2beisujb9aq9x">
          ⏱️ LESS SEARCHING. MORE READY-TO-USE DIAGNOSTICS.
        </h2>

        <ul className="mt-2 grid gap-1 sm:grid-cols-2" data-id="element-165" data-mp="2gfolyi8twfjz">
          {NEEDS.map(({
          need,
          answer
        }) => <li key={need} className="rounded-md border-l-4 border-volt bg-white/5 px-2.5 py-1.5 text-[13px] font-medium leading-snug text-white" data-id="element-166" data-mp="2kdmbxnafb5of">
              {need}
              {answer && <span className="ml-1 font-extrabold text-volt" data-id="element-167" data-mp="35wssldhgz4yj">{answer}</span>}
            </li>)}
        </ul>

        <p className="mt-2 text-center font-display text-base uppercase leading-tight text-volt sm:text-2xl" data-id="element-168" data-mp="30y7ubjls2vcq">
          Open the system. Choose the fault. Find the path. Follow the tests.
        </p>
      </div>
    </section>;
}